export function scrollToSection(target: string) {
  if (typeof window === "undefined") return;
  if (!target.startsWith("#")) return;

  const id = target.replace("#", "");
  const element = document.getElementById(id);
  if (!element) return;

  // Get banner height from CSS variable (set by TopBanner component)
  const bannerHeightStr = getComputedStyle(document.documentElement)
    .getPropertyValue("--banner-height")
    .trim();
  const bannerHeight = parseFloat(bannerHeightStr.replace("px", "")) || 0;

  // Get navbar element by ID
  const navbarContainer = document.getElementById("navbar-container") as HTMLElement;
  const navbarHeight = navbarContainer?.offsetHeight ?? 80; // Fallback to ~80px if not found

  // Calculate total header height (banner + navbar + extra spacing for visibility)
  const totalHeaderHeight = bannerHeight + navbarHeight + 2; // 20px extra spacing

  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY + rect.top - totalHeaderHeight;

  window.scrollTo({
    top: Math.max(0, scrollTop), // Ensure we don't scroll to negative values
    behavior: "smooth",
  });
}

